import React, { useState } from "react";
// import "./Modal.css";

/**
 * Modal potwierdzenia usunięcia wniosku
 */
const DeleteApplicationModal = ({ onConfirm, onCancel }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      await onConfirm();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div
        className="modal-content card d-flex flex-column w35 p-2"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header mb-1">
          <h4>Usuwanie wniosku</h4>
          <button
            type="button"
            className="btn-close"
            onClick={onCancel}
            aria-label="Close"
          />
        </div>

        <div className="flex-column mb-3">
          <p className="mb-0">Czy na pewno chcesz usunąć ten wniosek?</p>
          <small className="text-muted">Ta akcja nie może być cofnięta.</small>
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-outline-primary w7 h2"
            onClick={onCancel}
            disabled={isLoading}
          >
            Anuluj
          </button>
          <button
            type="button"
            className="btn btn-danger w7 ms-1 h2"
            onClick={handleConfirm}
            disabled={isLoading}
          >
            {isLoading ? "Usuwam..." : "Usuń"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteApplicationModal;
